<template>
    <!-- <v-layout row> -->
  <div>
    <v-navigation-drawer v-model="drawer" permanent app >
      <v-toolbar flat height="100px">
              <img class="ml-5" src="../assets/images/logga_small.png">
      </v-toolbar>
      <v-divider class="mb-3"></v-divider>
      <h3 v-if="issuperuser" class="ml-3">Kunder</h3>
      <v-list v-if="issuperuser">
        <v-list-tile v-for="kund in kunder" :key="kund.id" @click="selectkund(kund.id)" active-class="highlighted" :class="kund.id === selectedkund.id ? 'highlighted' : ''">
          <v-list-tile-content>
            <v-list-tile-title @click="selectkund(kund.id)">{{ kund.namn }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-btn v-if="issuperuser" class="mt-2 ml-3" color="primary" @click="opennewkund()">Ny kund</v-btn>
      <v-btn class="mt-2 ml-3" color="primary" @click="openepostlista()">Epostlista</v-btn>
      <v-btn class="mt-2 ml-3" to="/logout">Logga ut</v-btn>
    </v-navigation-drawer>
    <v-layout row>
      <v-flex lg10>
        <v-container>
          <v-tabs v-if="issuperuser" v-model="selectedtab">
            <!-- fixed-tabs -->
            <v-tab key="0">Allm�nt</v-tab>
            <v-tab key="1">Anv�ndare</v-tab>
            <v-tab key="2">Utbildningar</v-tab>
            <v-tab key="3">Bilder</v-tab>
            <v-tab-item key="0">
              <v-card flat>
                <v-card-text>
                  <v-card flat class="pl-3">
                    <v-text-field v-if="selectedkund" v-model="selectedkund.namn" label="Kundnamn" required></v-text-field>
                  </v-card>
                  <v-card flat color="grey lighten-5" class="pa-3">
                    <v-form>
                      <h3 class="mb-3">Administrat�r</h3>
                      <v-layout row>
                        <v-flex>
                          <v-text-field v-if="selectedkund" v-model="selectedkund.adminFornamn" label="F�rnamn" required></v-text-field>
                        </v-flex>
                        <v-flex ml-3>
                          <v-text-field v-if="selectedkund" v-model="selectedkund.adminEfternamn" label="Efternamn" required></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex>
                          <v-text-field v-if="selectedkund" v-model="selectedkund.adminEpost" :rules="emailRules" label="Epost" required></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex>
                          <v-text-field v-if="selectedkund" v-model="selectedkund.adminLosenord" type="password" label="L�senord" required></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card>
                  <v-card flat class="pl-3 pt-3">
                    <v-layout row>
                      <v-flex xs4>
                        <v-menu v-if="selectedkund"
                                v-model="licensdlg"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="licensdatum"
                                    label="Licens l�per ut"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker v-model="licensdatum" @input="licensdlg = false" locale='se'></v-date-picker>
                              </v-menu>
                      </v-flex>
                      <v-flex offset-lg2>
                        <v-radio-group v-model="aktiv" :mandatory="false" row>
                          <span>Status:</span>
                          <v-radio label="Aktiv" value="true"></v-radio>
                          <v-radio label="Inaktiv" value="false"></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs4>
                        <v-text-field v-if="selectedkund" readonly v-model="selectedkund.kringkringFil" label="Kring-kring/f�retaget" required></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <label for="file-upload"><span class="v-btn">Ladda upp</span></label>
                        <input v-show="showfiledialog" id="file-upload" type="file" @change="onKringkringChange">
                        <v-btn  @click="deleteKringkring()">Ta bort</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-btn color="primary" @click="saveallmant(selectedkund)">Spara</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="1">
              <v-card flat>
                <v-card-text>
                    <v-data-table :headers="anvandareheaders" :items="anvandareitems" class="elevation-1" :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                      <template slot="items" slot-scope="props">
                        <tr @click="toggleexpand(props)">
                          <td>{{ props.item.fornamn + ' ' + props.item.efternamn }}</td>
                          <td class="text-xs-right">{{ props.item.senastAktiv | dateonly}}</td>
                          <td >{{ props.item.antalGodkandaUtbildningar }}</td>
                          <td class="text-xs-right">{{ props.item.aktiv ? 'Aktiv' : 'Inaktiv' }}</td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <v-card flat color="grey lighten-5" class="pa-3">
                          <v-form>
                          <v-layout row>
                            <v-flex xs6>
                              <v-layout row>
                                <v-flex xs6>
                                  <v-text-field v-if="anvandaredetalj" v-model="anvandaredetalj.fornamn" label="F�rnamn" required></v-text-field>
                                </v-flex>
                                <v-flex xs6 ml-3>
                                  <v-text-field v-if="anvandaredetalj" v-model="anvandaredetalj.efternamn" label="Efternamn" required></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout row>
                                <v-flex xs6>
                                  <v-text-field v-if="anvandaredetalj" v-model="anvandaredetalj.epost" label="E-post / login" required></v-text-field>
                                </v-flex>
                                <v-flex xs6 ml-3>
                                  <v-text-field v-if="anvandaredetalj" v-model="anvandaredetalj.losenord" type="password" label="L�senord" required></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout row>
                                <v-checkbox v-if="anvandaredetalj" v-model="anvandaredetalj.aktiv" label='Aktiv'></v-checkbox>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 ml-3>
                              <label>Godk�nda utbildningar</label>
                              <v-list v-if="anvandaredetalj">
                                <v-list-tile v-for="item in anvandaredetalj.anvandareUtbildningar" :key="item.utbildningId">
                                  <v-list-tile-content>
                                    <v-list-tile-title v-text="item.utbildningsnamn"></v-list-tile-title>
                                  </v-list-tile-content>
                                  <v-list-tile-action>
                                       <v-text v-if="item.procent > 0 && item.godkand"><strong>{{ Math.round(item.procent) }}%</strong><v-icon :class="'okcolor'">{{ 'done'}}</v-icon></v-text>
                                       <v-text v-if="item.godkand === null"><strong style="padding-right: 22px;"> - </strong></v-text>
                                       <v-text v-if="item.procent > 0 && item.godkand === false"><strong>{{ Math.round(item.procent) }}%</strong><v-icon :class="'notokcolor'">{{ 'clear'}}</v-icon></v-text>
                                  </v-list-tile-action>
                                </v-list-tile>
                              </v-list>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs2 offset-xs11>
                              <v-btn color="primary" @click="saveanvandardetalj(anvandaredetalj)">Spara</v-btn>
                            </v-flex>
                          </v-layout>
                          </v-form>
                        </v-card>
                      </template>
                    </v-data-table>
                    <v-btn class="mt-3" color="primary" @click="shownewanvandare = true">Ny anv�ndare</v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="issuperuser" key="2">
              <v-card flat>
                  <v-card-text>
                    <v-data-table :headers="utbildningarheaders" :items="utbildningaritems" class="elevation-1" disable-initial-sort :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td>{{ props.item.namn }}</td>
                          <td><v-switch class="mt-3 mb-0" v-model="props.item.aktivPaKund" ></v-switch></td>
                          <td><v-text-field class="mt-3 mb-0" solo v-model="props.item.sortering"></v-text-field></td>
                        </tr>
                      </template>
                    </v-data-table>
                    <v-layout row mt-3>
                      <v-flex>
                        <v-btn color="primary" @click="saveutbildningkund(utbildningaritems)">Spara</v-btn>
                        <label for="file-upload1"><span class="v-btn primary">Ladda upp utbildning</span></label>
                        <input v-show="showfiledialog" id="file-upload1" type="file" @change="onUtbildningChange">
                      </v-flex>
                    </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="issuperuser" key="3">
              <v-card flat>
                  <v-card-text>
                    <v-data-table :headers="bilderheaders" :items="bilderitems" class="elevation-1" disable-initial-sort :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td>{{ props.item.bildnamn }}</td>
                          <img height="100px" :src="props.item.bild">
                        </tr>
                      </template>
                    </v-data-table>
                    <v-layout row mt-3>
                      <v-flex>
                        <label for="bild-upload"><span class="v-btn primary">Ladda upp bild</span></label>
                        <input v-show="showfiledialog" id="bild-upload" type="file" @change="onUtbildningChange">
                      </v-flex>
                    </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>

          </v-tabs>

          <v-tabs v-if="!issuperuser" v-model="selectedtab">
            <v-tab key="0">Anv�ndare</v-tab>
            <v-tab-item key="0">
              <v-card flat>
                <v-card-text>
                    <v-data-table :headers="anvandareheaders" :items="anvandareitems" class="elevation-1" :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                      <template slot="items" slot-scope="props">
                        <tr @click="toggleexpand(props)">
                          <td>{{ props.item.fornamn + ' ' + props.item.efternamn }}</td>
                          <td class="text-xs-right">{{ props.item.senastAktiv | dateonly}}</td>
                          <td >{{ props.item.antalGodkandaUtbildningar }}</td>
                          <td class="text-xs-right">{{ props.item.aktiv ? 'Aktiv' : 'Inaktiv' }}</td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <v-card flat color="grey lighten-5" class="pa-3">
                          <v-form>
                            <v-layout row>
                              <v-flex xs6>
                                <v-layout row>
                                  <v-flex xs6>
                                    <v-text-field readonly v-model="anvandaredetalj.fornamn" label="F�rnamn" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs6 ml-3>
                                    <v-text-field readonly v-model="anvandaredetalj.efternamn" label="Efternamn" required></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex xs6>
                                    <v-text-field readonly v-model="anvandaredetalj.epost" label="E-post / login" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs6 ml-3>
                                    <v-text-field readonly v-model="anvandaredetalj.losenord" type="password" label="L�senord" required></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-checkbox readonly v-model="anvandaredetalj.aktiv" label='Aktiv'></v-checkbox>
                                </v-layout>
                              </v-flex>
                              <v-flex xs6 ml-3>
                                <label>Godk�nda utbildningar</label>
                                <v-list>
                                  <v-list-tile v-for="item in anvandaredetalj.anvandareUtbildningar" :key="item.utbildningId">
                                    <v-list-tile-content>
                                      <v-list-tile-title v-text="item.utbildningsnamn"></v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <!-- <v-icon v-if="item.genomford" :class="[item.godkand ? 'okcolor' : 'notokcolor']">{{ item.godkand ? 'done': 'clear' }}</v-icon> -->
                                       <v-icon v-if="item.genomford" :class="'okcolor'">{{ item.godkand ? 'done': '' }}</v-icon>
                                       <v-text v-if="item.genomford" :class="'okcolor'">{{ item.godkand ? '': item.procent }}</v-text>
                                       <v-icon v-if="item.godkand === false" :class="'notokcolor'">{{'clear'}}</v-icon>
                                    </v-list-tile-action>
                                  </v-list-tile>
                                </v-list>
                              </v-flex>
                            </v-layout>
                          </v-form>
                        </v-card>
                      </template>
                    </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-flex>
    </v-layout>
     <v-snackbar success color="success" v-model="showsnackbar" :timeout="timeout">
      {{ snackbartext }}
      <v-btn
        dark
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="shownewanvandare" width="500">
      <v-card>
        <v-card-title class="info">
          Ny anv�ndare
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field v-if="newanvandare" v-model="newanvandare.fornamn" label="F�rnamn" required></v-text-field>
              </v-flex>
              <v-flex xs6 ml-3>
                <v-text-field v-if="newanvandare" v-model="newanvandare.efternamn" label="Efternamn" required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field v-if="newanvandare" v-model="newanvandare.epost" label="E-post / login" required></v-text-field>
              </v-flex>
              <v-flex xs6 ml-3>
                <v-text-field v-if="newanvandare" v-model="newanvandare.losenord" type="password" label="L�senord" required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-checkbox v-if="newanvandare" v-model="newanvandare.aktiv" label='Aktiv'></v-checkbox>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="shownewanvandare=false">Avbryt</v-btn>
          <v-btn color="primary" flat @click="savenewanvandare()">Spara</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="shownewkund" width="500">
      <v-card>
        <v-card-title class="info">
          Ny kund
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field v-if="newkund" v-model="newkund.namn" label="Kundnamn" required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field v-if="newkund" v-model="newkund.adminFornamn" label="F�rnamn" required></v-text-field>
              </v-flex>
              <v-flex xs6 ml-3>
                <v-text-field v-if="newkund" v-model="newkund.adminEfternamn" label="Efternamn" required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field v-if="newkund" v-model="newkund.adminEpost" label="E-post / login" required></v-text-field>
              </v-flex>
              <v-flex xs6 ml-3>
                <v-text-field v-if="newkund" v-model="newkund.adminLosenord" type="password" label="L�senord" required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-checkbox v-if="newkund" v-model="newkund.aktiv" label='Aktiv'></v-checkbox>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="shownewkund=false">Avbryt</v-btn>
          <v-btn color="primary" flat @click="savenewkund()">Spara</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showepostlista" width="800">
      <v-card>
        <v-card-title class="info">
          Epostlista
          <v-spacer></v-spacer>
          <v-btn @click="showepostlista=false">St�ng</v-btn>
        </v-card-title>
        <v-card-text>
          <v-form>
            <table>
              <tr v-for="item in epostlistaitems" :key="item.id">
                <td>{{ item.namn }}&nbsp;&nbsp;&nbsp;&nbsp;</td>
                <td>{{ item.foretag }}&nbsp;&nbsp;&nbsp;&nbsp;</td>
                <td>{{ item.epost }}&nbsp;&nbsp;&nbsp;&nbsp;</td>
                <td>{{ item.roll }}&nbsp;&nbsp;&nbsp;&nbsp;</td>
              </tr>
            </table>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { HTTP } from '@/backend/client'

export default {
  name: 'Home',
  data () {
    return {
      drawer: true,
      kunder: [],
      selectedkund: null,
      selectedtab: 0,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      licensdlg: false,
      licensdatum: null,
      aktiv: null,
      showsnackbar: false,
      snackbartext: null,
      timeout: 2000,
      issuperuser: false,
      anvandareheaders: [
        {text: 'Namn', value: 'namn', align: 'left'},
        {text: 'Senast aktiv', value: 'senastAktiv', align: 'right'},
        {text: 'Godk�nda utbildningar', value: 'antalGodkandaUtbildningar', align: 'left'},
        {text: 'Status', value: 'aktiv', align: 'right'}
      ],
      anvandareitems: [],
      anvandaredetalj: null,
      utbildningarheaders: [
        {text: 'Namn', value: 'namn'},
        {text: 'Aktiv p� kund', value: 'aktivPaKund'},
        {text: 'Sortering', value: 'sortering', width: 10}
      ],
      bilderheaders: [
        {text: 'Bildnamn', value: 'bildnamn'},
        {text: 'Bild', value: 'bild'}
      ],
      utbildningaritems: [],
      epostlistaitems: [],
      bilderitems: [],
      newanvandare: null,
      newkund: null,
      shownewanvandare: false,
      shownewkund: false,
      showepostlista: false,
      localfile: null,
      uploadtype: null,
      showfiledialog: false,
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        rowsPerPage: 20
      }
    }
  },
  created () {
    HTTP.get('/kund/issuperuser/')
      .then(response => {
        this.issuperuser = response.data
      })
    HTTP.get('/account/checkauthorization').then(response => {
      this.createnewanvandare()
    })
  },
  mounted () {
    HTTP.get('/account/checkauthorization').then(response => {
      this.getallkunder()
      this.getbilder()
    })
  },
  methods: {
    getallkunder () {
      HTTP.get('/kund/getall/')
        .then(response => {
          this.kunder = response.data
          if (this.kunder.length > 0) {
            this.getcurrentkund(this.kunder[0])
          }
        })
    },
    selectkund (kundid) {
      HTTP.get('/kund/get/' + kundid)
        .then(response => {
          this.getcurrentkund(response.data)
        })
        .catch(e => {
          this.$store.dispatch('appcurrent/showError', e.message)
        })
    },
    getcurrentkund (kund) {
      if (!kund) return
      this.selectedkund = kund
      this.licensdatum = kund.licensLoperUt && kund.licensLoperUt.substring(0, 10)
      this.aktiv = kund.aktiv.toString()
      this.getanvandare(kund.id)
      this.getutbildningar(kund.id)
    },
    getanvandare (kundid) {
      HTTP.get('/anvandare/getanvandare/' + kundid).then(response => {
        this.anvandareitems = response.data
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    getutbildningar (kundid) {
      HTTP.get('/utbildning/getutbildning/' + kundid).then(response => {
        this.utbildningaritems = response.data
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    getbilder (kundid) {
      HTTP.get('/utbildning/getbilder/').then(response => {
        this.bilderitems = response.data
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    saveutbildningkund (utbildningaritems) {
      HTTP.post('/utbildning/saveutbildningkund', utbildningaritems).then(response => {
        this.snackbartext = 'Utbildningar sparade'
        this.showsnackbar = true
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    toggleexpand (props) {
      props.expanded = !props.expanded
      if (props.expanded) {
        HTTP.get('/anvandare/getanvandaredetalj/' + props.item.id).then(response => {
          this.anvandaredetalj = response.data
        }).catch(e => {
          this.$store.dispatch('appcurrent/showError', e.message)
        })
      }
    },
    saveallmant (kund) {
      // TEST --------------------------------------------------
      // HTTP.get('/utbildning/getutbildningperanvandare/maria.andersson@klivet.se')
      //   .then(response => {
      //     this.showsnackbar = true
      //   })
      //   .catch(e => {
      //     this.$store.dispatch('appcurrent/showError', e.message)
      //   })
      // -------------------------------------------------------
      if (!kund) return

      kund.licensLoperUt = this.licensdatum
      kund.aktiv = this.aktiv === 'true'

      HTTP.post('/kund/saveallmant', kund).then(response => {
        this.snackbartext = 'Informationen sparad'
        this.showsnackbar = true
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    saveanvandardetalj (anvandaredetalj) {
      if (!anvandaredetalj) return

      HTTP.post('/anvandare/saveanvandardetalj', anvandaredetalj).then(response => {
        this.snackbartext = 'Anv�ndaruppgifter sparade'
        this.showsnackbar = true
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    createnewanvandare () {
      HTTP.get('/anvandare/getnewanvandare').then(response => {
        this.newanvandare = response.data
      })
    },
    createnewkund () {
      HTTP.get('/kund/getnewkund').then(response => {
        this.newkund = response.data
      })
    },
    opennewkund () {
      this.createnewkund()
      this.shownewkund = true
    },
    savenewanvandare () {
      this.shownewanvandare = false
      this.newanvandare.kundId = this.selectedkund.id
      HTTP.post('/anvandare/savenewanvandare', this.newanvandare).then(response => {
        this.snackbartext = 'Anv�ndare sparad'
        this.showsnackbar = true
        this.getanvandare(this.selectedkund.id)
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    savenewkund () {
      this.shownewkund = false
      HTTP.post('/kund/savenewkund', this.newkund).then(response => {
        this.snackbartext = 'Kund sparad'
        this.showsnackbar = true
        this.getallkunder()
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    openepostlista () {
      HTTP.get('/anvandare/getepostlista/').then(response => {
        this.epostlistaitems = response.data
        this.showepostlista = true
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    },
    onUtbildningChange (e) {
      this.uploadtype = 'utbildning'
      this.onFileChange(e)
    },
    onKringkringChange (e) {
      this.uploadtype = 'kringkring'
      this.onFileChange(e)
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }

      for (var i = 0; i < files.length; i++) {
        this.createfile(files[i])
      }
      this.filename = null
      e.target.value = null
    },
    createfile (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        self.localfile = {
          filedata: btoa(e.target.result),
          filename: file.name,
          filesize: file.size,
          filetype: file.type,
          email: self.selectedkund.adminEpost,
          kundnamn: self.selectedkund.namn
        }
        if (self.uploadtype === 'utbildning') {
          self.saveattachementutbildning()
        } else {
          self.saveattachementkringkring()
        }
        file = null
      }
      reader.readAsBinaryString(file)
    },
    saveattachementutbildning () {
      // this.$store.dispatch('appcurrent/showWorkingStatus')
      var uploadname
      if (this.localfile.filename.endsWith('.csv')) {
        uploadname = '/utbildning/savelocalutbildning'
      } else {
        uploadname = '/utbildning/savelocalbild'
      }
      HTTP.post(uploadname, this.localfile)
        .then(response => {
          this.getutbildningar(this.selectedkund.id)
          this.getbilder()
        }).catch(e => {
          this.$store.dispatch('appcurrent/showError', e.response.data)
        })
        // .then(r => {
        //   this.$store.dispatch('appcurrent/clearWorkingStatus')
        // })
    },
    saveattachementkringkring () {
      // this.$store.dispatch('appcurrent/showWorkingStatus')
      HTTP.post('/kund/savekringkring', this.localfile)
        .then(response => {
          this.selectkund(this.selectedkund.id)
        }).catch(e => {
          this.$store.dispatch('appcurrent/showError', e.response.data)
        })
        // .then(r => {
        //   this.$store.dispatch('appcurrent/clearWorkingStatus')
        // })
    },
    deleteKringkring () {
      HTTP.post('/kund/deleteKringkring', this.selectedkund).then(response => {
        this.selectkund(this.selectedkund.id)
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
      })
    }
    // deletekund () {
    //   this.showdeletekund = false
    //   HTTP.post('/kund/deletekund', this.selectedkund.id)
    //     .then(response => {
    //       this.snackbartext = 'Kund raderad'
    //       this.showsnackbar = true
    //       this.getallkunder()
    //     })
    //     .catch(e => {
    //       this.$store.dispatch('appcurrent/showError', e.message)
    //     })
    // }

    // godkann () {
    //   HTTP.post('/utbildning/godkannanvandare', {epost: 'maria.andersson@klivet.se', utbildningid: 2})
    //     .then(response => {
    //       this.snackbartext = 'Anv�ndaruppgifter sparade'
    //       this.showsnackbar = true
    //     })
    //     .catch(e => {
    //       this.$store.dispatch('appcurrent/showError', e.message)
    //     })
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue